export default __webpack_public_path__ + "static/media/nick-offerman-murray-bartlett_2.b46d262f.jpg";